import React, { memo } from 'react';

import isEmpty from './util/isEmpty';
import { Flex, Circle } from '@mss/mss-component-library';

const BulletTitle = ({
  children,
  className = '',
}: React.ComponentProps<'div'>) => (
  <div className={`ml-[5px] pb-0.5 ${className}`}>{children}</div>
);

export default memo(function ({
  size,
  text,
  hideText,
}: {
  size: number;
  text: any;
  hideText?: boolean;
}) {
  let hideUnavailable = false;
  let italic = false;
  let color = '#000000ff';

  if (typeof text !== 'string') {
    hideUnavailable = text.hideUnavailable;
    italic = text.italic;
    text = text.data;
  }

  const parsedText = text.toLowerCase();

  if (
    parsedText === 'ready' ||
    parsedText === 'success' ||
    parsedText === 'ok' ||
    (!parsedText.includes('exception') && !parsedText.includes('error'))
  ) {
    color = '#00cc00';
  } else if (
    parsedText === 'fail' ||
    parsedText === 'failed' ||
    parsedText === 'error' ||
    parsedText.includes('exception')
  ) {
    color = '#d9534f';
  } else if (parsedText === 'standby') {
    color = '#fce464';
  } else {
    if (isEmpty(text) && hideUnavailable) {
      if (!italic) {
        return null;
      } else {
        return <i>Unknown</i>;
      }
    }
    color = '#808080';
    text = 'Unavailable';
  }

  return (
    <Flex v="center">
      <Circle size={size} color={color} title={text} />
      {hideText ? (
        <div className="ml-2"></div>
      ) : (
        <BulletTitle className="ml-2">{text}</BulletTitle>
      )}
    </Flex>
  );
});
